import { UserType } from "./user";

export enum ProfileAction {
    UPDATE_PROFILES = 'UPDATE_PROFILES',
    CREATE_PROFILE = 'CREATE_PROFILE'
}
interface Drill {
    drillType: string,
    periodType?: string
}

export interface ProfileType {
  _id?: string;
  profileName: string;
  description: string;
  last_modified: number;
  drills: Drill[];
  intensity: string;
  siteId: string;
  teamId: string;
  startTime: number;
  type: string;
  league: string;
  created_by: string;
}
export interface UpdateProfilesAction {
    type: ProfileAction.UPDATE_PROFILES;
    data: ProfilesState;
}


export type ProfilesState = Record<string, ProfileType[]>;

export type ProfilesActions = UpdateProfilesAction;